import {
    CONTACT_COUNTRY_CODE_TEST_ID,
    CONTACT_PHONE_TEST_ID,
} from "@e2e/helpers/checkout/components/contact-details/constants";
import { Flex } from "@ecco/ui/flex";
import { fieldStateHelper } from "@lib/utils/form/fieldStateHelper/fieldStateHelper";
import type { ContactDetailsInitialValues } from "@lib/utils/checkoutHelper";
import { useFormContext, useFormState } from "react-hook-form";
import TextInputField from "@components/ui/form/TextInputField/TextInputField";
import { Box } from "@ecco/ui/box";

type PhoneNumberFieldProps = {
    countryCodeLabel: string;
    phoneNumberLabel: string;
    helpText: string;
};

export default function PhoneNumberField({
    countryCodeLabel,
    phoneNumberLabel,
    helpText,
    ...inputProps
}: PhoneNumberFieldProps) {
    const { register, formState } = useFormContext<ContactDetailsInitialValues>();
    const { errors, touchedFields } = useFormState<ContactDetailsInitialValues>();
    const { getFieldStateProps, getIconProps } = fieldStateHelper({
        errors,
        touched: touchedFields,
        isSubmitted: formState.isSubmitted,
        type: "hook-form",
    });

    const { isInvalid: isPhoneInvalid, ...restPhoneFieldStateProps } = getFieldStateProps("phone");

    return (
        <Flex gap={[0, 0, 2]}>
            <Box width={120}>
                <TextInputField
                    tabIndex={-1}
                    {...register("countryCode")}
                    name="countryCode"
                    header={countryCodeLabel}
                    aria-hidden="true"
                    data-testid={CONTACT_COUNTRY_CODE_TEST_ID}
                    isReadOnly
                    onFocus={() => {
                        const phoneEls = document?.getElementsByName("phone");
                        phoneEls?.[0]?.focus();
                    }}
                />
            </Box>

            <TextInputField
                {...register("phone")}
                {...restPhoneFieldStateProps}
                {...getIconProps("phone")}
                testId={CONTACT_PHONE_TEST_ID}
                header={phoneNumberLabel}
                helpText={helpText}
                isInvalid={isPhoneInvalid}
                aria-invalid={isPhoneInvalid}
                name="phone"
                type="tel"
                autoComplete="nope"
                {...inputProps}
            />
        </Flex>
    );
}
